module.exports = __webpack_public_path__ + "img/40_38_053_880.c7ce504b.jpg";